const config ={
    center:[603403.33697965 , 5356473.80219608],
    zoom:11.7,
    contenu:[
        {
            thematique:`Associations professionnelles`,
            picto:`associations_professionnelles.svg`,
            titre:`Associations professionnelles`,
            soustitre:`Marseille dispose d'une filière dynamique et structurée de plus d'une dizaine d'associations.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Studios et Infrastructures`,
            picto:`studios.svg`,
            titre:`Studios et infrastructures`,
            soustitre:`En 2019, 6 studios et 27 plateaux de tournage sur 15 559 m² recensés à l'échelle régionale.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Cinéma`,
            picto:`cinemas.svg`,
            titre:`Cinémas et lieux de diffusion`,
            soustitre:`14 cinémas marseillais labellisés par le CNC, 75 salles, plus de 12 000 fauteuils, 10 exploitants.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Lieux de formation et d'éducation à l'image`,
            picto:`lieux_formation.svg`,
            titre:`Lieux de formation et d'éducation à l'image`,
            soustitre:`Une vingtaine de formations couvrent l'ensemble des métiers du cinéma et de l'audiovisuel à Marseille. Plus de 70 formations au niveau régional. Une vingtaine de sites dédiés à l'éducation à l'image.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Bureaux d'accueils de tournages`,
            picto:`accueil_tournage.svg`,
            titre:`Bureaux d'accueil de tournages`,
            soustitre:`Sur 17 commissions du film et bureaux d'accueil de tournages régionaux, 10 sont recensés dans les Bouches-du-Rhône.​`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Ressources techniques`,
            picto:`ressources_techniques.svg`,
            titre:`Ressources techniques`,
            soustitre:`Marseille compte 1 500 techniciens qualifiés, 166 sociétés de production.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Musées`,
            picto:`musees.svg`,
            titre:`Musées`,
            soustitre:`Marseille dispose d'une quinzaine de musées municipaux.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Bibliothèques`,
            picto:`bibliotheques.svg`,
            titre:`Bibliothèques`,
            soustitre:`9 bibliothèques municipales dont 2 médiathèques composent l'écho-système culturel marseillais.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Opéra Odéon`,
            picto:`opera.svg`,
            titre:`Opéra Odéon`,
            soustitre:`1 opéra municipal inauguré en 1787 (1 800 places) et 1 théâtre municipal, l'Odéon, ouvert depuis 1923 (800 places). `,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Tiers-lieux`,
            picto:`tierslieux.svg`,
            titre:`Tiers-lieux`,
            soustitre:`Marseille est maillée d'espaces de coworking, d'ateliers partagés, de friches culturelles, d'espaces de production artistique ou encore de cités d'artistes.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Sociétés de production`,
            picto:`societe_production.svg`,
            titre:`Sociétés de production`,
            soustitre:`A l'échelle régionale, plus de 150 sociétés de production oeuvrent sur des formats courts et longs-métrages, fictions et documentaires, séries TV, émissions de flux, publicités…`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`Archives`,
            picto:`archives.svg`,
            titre:`Archives`,
            soustitre:`Une dizaine de sites à Marseille sont consacrés à la conservation, à la numérisation des fonds audiovisuels régionaux, à la sauvegarde et à la restauration de films.`,
            integrer:true,
            afficher:true,
            popup:false
        },
        {
            thematique:`ressources humaines`,
            picto:`ressources_humaines.svg`,
            titre:`Ressources humaines`,
            soustitre:`377 auteurs littéraires, scénaristes et dialoguistes implantés dans les Bouches-du-Rhône. 970 comédiens au niveau départemental.​`,
            integrer:false,
            afficher:true,
            popup:false
        },
        {
            thematique:`festivals`,
            picto:`30_festivals.svg`,
            titre:`Festivals`,
            soustitre:`​60 festivals régionaux dont plus de 22 à Marseille.`,
            integrer:false,
            afficher:true,
            popup:true
        },
        {
            thematique:`Bureaux d'accueils de tournages`,
            picto:`accueil_tournage.svg`,
            titre:`Bureaux d'accueils de tournages`,
            soustitre:``,
            integrer:false,
            afficher:true,
            popup:true
        },
        
    ]
}
export default config;